import { constants, mediaQueryStyles } from "@newsela/angelou";

const { breakpoints } = constants;
const { mediaQuery } = mediaQueryStyles;
const { xs } = breakpoints.BreakpointNames;

export const detailsCss = {
  width: "100%",
  maxWidth: "720px",
  marginBottom: "48px",

  [mediaQuery.upTo(xs)]: {
    marginBottom: "24px",
    maxWidth: "100vw",
    padding: "24px 16px 0",
  },
};
